// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-page-upgrade-UpgradeSteps-module__root--3Dg-x","override":"src-components-page-upgrade-UpgradeSteps-module__override--2MXuK"};